<ng-container *ngIf="(role$ | async) === RoleEnum.DISPO; else poolerJobsIndex">
  <app-dispo-jobs-index></app-dispo-jobs-index>
</ng-container>
<ng-template #poolerJobsIndex>
  <app-pooler-jobs-index></app-pooler-jobs-index>
</ng-template>
